import * as React from "react";

import Typography from "@mui/material/Typography";
import Container from "../../components/layout/container";
// import PageLayout from "../../components/layout/page-layout";
// import Container from "components/layout/container";
// import PageLayout from "components/layout/page-layout";
// import { Button } from "components/button/button";

import styles from "./home-page.module.css";

const HomePage = () => {
  return (
    <Container>
      <Typography
        component="h1"
        variant="h2"
        align="center"
        color="text.primary"
        gutterBottom
      >
        Home page
      </Typography>
    </Container >
  );
};

export default HomePage;
